export default Object.freeze({
  CurrentUserRequests: 1,
  InstanceStatus: 2,
  FormFieldValue: 3,
  CurrentUserPendingRequests: 4,
  CurrentUserPendingCompleteInformationRequests: 5,
  CurrentUserPendingApprovalsRequests: 6,
  CurrentUserPendingExecuteTasksRequests: 7,
  CurrentUserPendingSignRequests: 8,
  CurrentUserInteractionsRequests: 9,
  VariableValue: 10,
});
